module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[89]332.7cb7c1c.woff2";